import type { ReactElement } from 'react';

import { Box, Card, Flex, Grid } from '@rango-dev/whale';
import React from 'react';
import { useParams } from 'react-router-dom';

import { useAppSelector } from '../../../hooks/reduxHooks';
import { profileSummarySelector } from '../../../state/ProfileSlice/selectors';
import { ProfileFavorites } from '../ProfileFavorites';
import { ProfileSummaryItems } from '../ProfileSummaryItems';

import { ProfileSummaryEmptyState } from './ProfileSummaryEmptyState';

export function ProfileSummary(): ReactElement {
  const params = useParams<{ username: string }>();
  const { error } = useAppSelector((state) => profileSummarySelector(state, params.username));

  return (
    <Card variant="surface" size="3">
      {error ? (
        <ProfileSummaryEmptyState />
      ) : (
        <Flex direction="column" gap="4">
          <Grid columns={{ initial: '1', lg: '2' }} gapX="5" gapY="4">
            <ProfileSummaryItems />
          </Grid>
          <Box>
            <ProfileFavorites />
          </Box>
        </Flex>
      )}
    </Card>
  );
}
